import { PlanTab } from '../../../../../components/verification/SubscriptionStep';
import { SubscriptionTerm } from '../../../../../services/exports/Constants';

export default {
  sections: {
    term: {
      description: 'Maandelijks gefactureerd. Jaarlijks is een verbintenistermijn, geen factuurfrequentie.',
      options: {
        [SubscriptionTerm.Monthly]: 'Maandelijkse termijn',
        [SubscriptionTerm.Annual]: 'Jaarlijkse termijn',
      },
    },
    plans: {
      tabs: {
        [PlanTab.actual]: {
          name: 'Prijsmodel',
          title: 'Succesgebaseerde prijsschaal',
        },
        [PlanTab.legacy]: {
          name: 'Legacy',
          title: 'Abonnementen',
        },
      },
    },
    add_ons: {
      title: 'Word een Pro met onze add-ons voor uw Essential Plan',
      description: 'Trek nieuwe gasten aan en stimuleer herhalingsbezoeken met deze softwareoplossingen.',
    },
  },
  labels: {
    recommended: 'Aanbevolen',
    basket: 'Winkelwagen: <strong>{{amount}}</strong> per maand',
  },
  buttons: {
    review_and_subscribe: 'Bekijken en abonneren',
    cancel: 'Annuleren',
    basket: 'Terug naar winkelwagen',
    subscribe: 'Abonneren',
    update_subscription: 'Abonnement bijwerken',
  },
  toasts: {
    failed_to_load_data: 'Gegevens konden niet worden geladen',
    failed_to_save_contract: 'Servicecontract kon niet worden opgeslagen',
    failed_to_create_subscription: 'Abonnement kon niet worden aangemaakt',
    subscription_created: 'Abonnement is succesvol aangemaakt',
    subscription_updated: 'Abonnement is succesvol bijgewerkt',
  },
};
